module.exports = {
      id: "podcast-usage",
      viewBox: "0 0 104.071 88.89",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#podcast",
      toString: function () {
        return this.url;
      }
    }